import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import checkIcon from "../../../../../assets/pictures/icons/check-icon.svg";
import type { IRootState } from "../../../../../redux/store";
import styles from "./BackgroundSelection.module.scss";
import gradient from "../../../../../assets/pictures/scene/gradient.svg";
import tungsten from "../../../../../assets/pictures/scene/tungsten.svg";
import green from "../../../../../assets/pictures/scene/green.png";
import { changeFormData } from "../../../../../redux/slices/formSlice";

interface Scene {
	value: string;
	description: string;
}

const sceneImages: Record<string, string> = {
	"gradient": gradient,
	"tungsten": tungsten,
	"green": green,
};

export const BackgroundSelection: React.FC = () => {
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const dispatch = useDispatch();
	const scenes: Scene[] = useSelector((state: IRootState) => state.platformScenes);
	const currentScenes = scenes.map((el) => {
		return {
			...el,
			sceneImg: sceneImages[el.description],
		}
	})

	const [selectedBackground, setSelectedBackground] = useState<string | null>(
		currentScenes.length > 0 ? formData.scene : null,
	);

	const handleSelect = (value: string) => {
		setSelectedBackground(value);
		dispatch(changeFormData({ scene: value }));
	};

	return (
		<div className={styles.backgroundContainer}>
			<h5>Фон</h5>
			{currentScenes.length > 0 && (
				<div className={styles.backgrounds}>
					{currentScenes.map((el) => {
						const isSelected = selectedBackground === el.value;
						return (
							<label
								key={el.value}
								className={`${styles.backgroundOption} ${isSelected ? styles.selected : ""}`}
							>
								<input
									type="radio"
									name="background"
									value={el.value}
									checked={isSelected}
									onChange={() => handleSelect(el.value)}
									className={styles.hiddenRadio}
								/>
								<img src={el.sceneImg} alt={el.description} />
								{isSelected && (
									<div className={styles.checkmark}>
										<img src={checkIcon} alt="check icon" />
									</div>
								)}
							</label>
						);
					})}
				</div>
			)}
		</div>
	);
};
